import Newsletter from '../home/components/Newsletter';
import Footer from '../home/components/Footer';
import Navigation from '../../components/feature/Navigation';

export default function MorePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Contact Us Section */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
              Get In <span className="text-red-600">Touch</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto">
              Have questions, guest suggestions, or partnership opportunities? We'd love to hear from you.
            </p>
            
            {/* Contact Card */}
            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-3xl p-8 md:p-12 mb-12">
              <div className="flex flex-col items-center gap-6">
                <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-full">
                  <i className="ri-mail-line text-4xl text-white"></i>
                </div>
                
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                    Email Us
                  </h3>
                  <a 
                    href="mailto:info@themusclehustlepodcast.com"
                    className="text-xl md:text-2xl text-red-400 hover:text-red-300 transition-colors cursor-pointer"
                  >
                    info@themusclehustlepodcast.com
                  </a>
                </div>
                
                <p className="text-gray-400 text-lg max-w-xl">
                  Whether you're interested in being a guest, sponsoring the show, or just want to share your hustle story, drop us a line. We typically respond within 24-48 hours.
                </p>
              </div>
            </div>
            
            {/* Social Media Links */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-white mb-6">
                Connect With Us
              </h3>
              <div className="flex gap-4 justify-center flex-wrap">
                <a
                  href="https://twitter.com/themusclehustlepodcast"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-2xl text-white"></i>
                </a>
                <a
                  href="https://instagram.com/themusclehustlepodcast"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-2xl text-white"></i>
                </a>
                <a
                  href="https://linkedin.com/company/themusclehustlepodcast"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-line text-2xl text-white"></i>
                </a>
                <a
                  href="https://www.youtube.com/@themusclehustlepodcast"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-youtube-line text-2xl text-white"></i>
                </a>
                <a
                  href="https://open.spotify.com/show/0YDMrdRFUWloLaDufAsYVH?si=99uxCv_tTMKmcqP_gXkUlw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-spotify-fill text-2xl text-white"></i>
                </a>
                <a
                  href="https://podcasts.apple.com/us/podcast/the-muscle-hustle-podcast/id1677247639"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-apple-fill text-2xl text-white"></i>
                </a>
              </div>
            </div>
            
            {/* Quick Info Cards */}
            <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="bg-gray-800/30 border border-gray-700 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-600/20 rounded-full mx-auto mb-4">
                  <i className="ri-user-voice-line text-2xl text-red-400"></i>
                </div>
                <h4 className="text-lg font-bold text-white mb-2">Guest Inquiries</h4>
                <p className="text-gray-400 text-sm">
                  Interested in sharing your hustle story on the show?
                </p>
              </div>
              
              <div className="bg-gray-800/30 border border-gray-700 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-600/20 rounded-full mx-auto mb-4">
                  <i className="ri-briefcase-line text-2xl text-red-400"></i>
                </div>
                <h4 className="text-lg font-bold text-white mb-2">Partnerships</h4>
                <p className="text-gray-400 text-sm">
                  Explore sponsorship and collaboration opportunities
                </p>
              </div>
              
              <div className="bg-gray-800/30 border border-gray-700 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-600/20 rounded-full mx-auto mb-4">
                  <i className="ri-feedback-line text-2xl text-red-400"></i>
                </div>
                <h4 className="text-lg font-bold text-white mb-2">Feedback</h4>
                <p className="text-gray-400 text-sm">
                  Share your thoughts and suggestions with us
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Newsletter Section */}
      <Newsletter />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}
